import React from 'react';
import { Row, Col, FormGroup } from 'reactstrap';
import { editorUrl } from '@constants/defaultValues';
import './editor.styles.css';

const EditorPage = props => (
  <div id='mv-editor-container'>
    <div
      id='container-editor'
      className={
        'mv-editor-container' + (props.showEditor ? ' visivel' : ' hidden')
      }
      style={{ width: props.larguraEditor, right: 0 }}
    >
      <i
        className={
          'fas fa-save editor-save-icon' + (props.showIconSave ? ' show' : '')
        }
      ></i>
      <Row style={{ height: '100%' }}>
        <Col>
          <FormGroup
            style={{
              height: '100%',
              marginBottom: '-8px',
              overflow: 'auto'
            }}
          >
            <iframe
              sandbox='allow-scripts allow-same-origin allow-forms'
              id='iframe-editor'
              title='iframe-editor'
              src={editorUrl}
              style={{
                width: '100%',
                height: '100%',
                transition: '1400ms',
                borderColor: 'transparent',
                display: 'none'
              }}
              onLoad={props.carregarEditor}
              onError={error => console.log(error)}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  </div>
);

export default EditorPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/editor/editor.page.js